import { cn as e } from "../shared/utils.js";
import { cloneElement as t, createContext as n, isValidElement as r, useCallback as i, useContext as a, useImperativeHandle as o, useRef as s } from "react";
import { jsx as c } from "react/jsx-runtime";
import { Combobox as l } from "@base-ui/react/combobox";
import { useVirtualizer as u } from "@tanstack/react-virtual";
//#region src/combobox/virtualized-list.tsx
var d = n(null);
function f(e, t) {
	if (!e) return;
	let { reason: n, index: r } = t;
	if (r < 0) return;
	let i = r === 0, a = r === e.options.count - 1;
	(n === "none" || n === "keyboard" && (i || a)) && queueMicrotask(() => {
		e.scrollToIndex(r, { align: a ? "start" : "end" });
	});
}
function p(e, n, i) {
	if (!r(e)) return e;
	let a = e;
	return t(a, {
		index: a.props.index ?? n,
		"aria-setsize": i,
		"aria-posinset": n + 1
	});
}
function m({ children: t, estimateSize: n = 48, overscan: r = 8, className: f }) {
	let m = l.useFilteredItems(), h = a(d), g = s(null), _ = u({
		count: m.length,
		getScrollElement: () => g.current,
		estimateSize: () => n,
		overscan: r,
		paddingStart: 4,
		paddingEnd: 4,
		scrollPaddingStart: 4,
		scrollPaddingEnd: 4
	});
	o(h ?? void 0, () => _, [_]);
	let v = i((e) => {
		g.current = e, e && _.measure();
	}, [_]), y = _.getTotalSize();
	return m.length === 0 ? null : /* @__PURE__ */ c("div", {
		ref: v,
		role: "presentation",
		"data-slot": "combobox-virtualized",
		"data-testid": "combobox-virtualized",
		className: e("min-h-0 flex-1 overflow-y-auto overscroll-contain", f),
		children: /* @__PURE__ */ c("div", {
			className: "relative w-full shrink-0",
			style: { height: y },
			children: _.getVirtualItems().map((e) => {
				let n = m[e.index];
				return n === void 0 ? null : /* @__PURE__ */ c("div", {
					role: "presentation",
					"data-index": e.index,
					ref: _.measureElement,
					style: {
						position: "absolute",
						top: 0,
						left: 0,
						width: "100%",
						transform: `translateY(${e.start}px)`
					},
					children: p(t(n, e.index), e.index, m.length)
				}, e.key);
			})
		})
	});
}
m.displayName = "ComboboxPrimitive.VirtualizedList";
//#endregion
export { m as ComboboxVirtualizedList, d as ComboboxVirtualizerContext, f as scrollVirtualizedHighlight };
